import { ProductInfoTitle } from './Title';
import { ProductInfoPrice } from './Price';
import { ProductInfoItemSku } from './ItemSku';
import { Divider } from 'antd';
import { ProductInfoSkuGrid } from './SkuGrid';
import { useRef } from 'react';
import { ProductInfoImage } from './Image';

interface ProductInfoProps {
  storeId: Conversation.Conversation['storeId'];
  product: Conversation.Product;
  platform?: General.PlatformUpperCase;
}

export const ProductInfo = (props: ProductInfoProps) => {
  const { storeId, product, platform } = props;

  const {
    imageUrl,
    itemUrl,
    itemName,
    originalHighPrice,
    skuLowPrice,
    skuHighPrice,
    itemSku,
    unit,
    skuInfo,
  } = product;

  const containerRef = useRef<HTMLDivElement>(null);

  const imgUrl = imageUrl?.[0];

  return (
    <div ref={containerRef} className="flex gap-2 items-start px-[12px]">
      <ProductInfoImage imgUrl={imgUrl} itemName={itemName} platform={platform} />
      <div className="flex-1 min-w-0">
        <ProductInfoTitle title={itemName} url={itemUrl} />
        <ProductInfoPrice
          unit={unit}
          originalHighPrice={originalHighPrice}
          skuLowPrice={skuLowPrice}
          skuHighPrice={skuHighPrice}
        />
        <div className="flex mt-1 items-center">
          {!!itemSku && (
            <>
              <ProductInfoItemSku itemSku={itemSku} />
              <Divider type="vertical" className="!ml-0 !mr-[12px]" />
            </>
          )}
          <ProductInfoSkuGrid containerRef={containerRef} storeId={storeId} skuInfo={skuInfo} />
        </div>
      </div>
    </div>
  );
};
